import {Entity} from 'aurelia-orm';

export class AppEntity extends Entity {
    id: number;
    createdDate: Date;
    description: string;
    itemId: number;
    entityStatusId: number;
    isEditing: boolean;
	title: string;
	insertedBy: number;
	insertedName: string;
     
}